import React from 'react';
import type { TabsProps } from '../../../components/tabs/types';
import { Tabs } from '../../../components';

type Ref = HTMLDivElement;
interface Props extends TabsProps{
  children: React.ReactNode;
}

const TabsSection = React.forwardRef<Ref, Props>(({
  id,
  label,
  tabs,
  active,
  handleClick,
  children,
}: Props, ref) => (
  <div ref={ref} className={'bg-white rounded-default shadow overflow-x-hidden'}>
    <Tabs
      id={id as string}
      label={label}
      tabs={tabs}
      active={active}
      handleClick={handleClick}
    />
    <div className={'container border-b'}>
      {children}
    </div>
  </div>
));

TabsSection.displayName = 'TabsSection';

export default TabsSection;
